import React, { PureComponent } from 'react'
import Slider from 'react-slick'

import { NextArrow, PrevArrow } from 'components/ui/SliderArrows'

import LayoutWindow from 'mixins/LayoutWindow'

import './style'
import './media'

@LayoutWindow
class PartnersSlider extends PureComponent {
    SETTINGS = {
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        speed: 200,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        touchMove: true,
        focusOnSelect: true,
        swipeToSlide: true,
        infinite: true,
        centerMode: true,
    }

    render() {
        const { width, list = [] } = this.props

        let sliderSettings = {...this.SETTINGS}

        if (width <= 1300) {
            sliderSettings = {
                ...sliderSettings,
                slidesToShow: 5,
            }
        }
        
        if (width <= 900) {
            sliderSettings = {
                ...sliderSettings,
                slidesToShow: 4,
            }
        }
        
        if (width <= 700) {
            sliderSettings = {
                ...sliderSettings,
                slidesToShow: 3,
                dots: true,
                arrows: false,
            }
        }
        
        if (width <= 600) {
            sliderSettings = {
                ...sliderSettings,
                slidesToShow: 2,
                dots: true,
                arrows: false,
            }
        }
        
        if (width <= 450) {
            sliderSettings = {
                ...sliderSettings,
                slidesToShow: 1,
                dots: true,
                arrows: false,
                centerMode: false,
            }
        }

        if (list.length < sliderSettings.slidesToShow) {
            sliderSettings.slidesToShow = list.length
        }

        return (
            <Slider
                {...sliderSettings}

                className="partners-slider"
            >
                {list}
            </Slider>
        );
    }
}

export default PartnersSlider